import PropTypes from "prop-types";
import { memo } from "react";

import { Norealtime as NoRealtimeSVG } from "./icons";

import "./NoRealtimeIcon.scss";

const propTypes = {
  useFzo: PropTypes.bool,
};

function NoRealtimeIcon({ useFzo = true }) {
  return (
    <div
      className="trl-norealtime-icon"
      title={
        useFzo
          ? "Es liegt keine Echtzeitposition vor."
          : "Es liegen keine Echtzeitdaten vor."
      }
    >
      <NoRealtimeSVG data-testid="norealtime-icon" />
    </div>
  );
}

NoRealtimeIcon.propTypes = propTypes;

export default memo(NoRealtimeIcon);
